"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _InstallationPanel = require("./InstallationPanel");

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _Message = require("../../../ui-components/Message");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _SyncContentStatus = _interopRequireDefault(require("../SyncContentStatus"));

var _IntegrationFilter = _interopRequireDefault(require("./IntegrationFilter"));

var _constants = require("@insided/shared/constants");

var _utils = require("../../utils");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isFederatedSearchActive = _ref.isFederatedSearchActive,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onSettingChanged = _ref.onSettingChanged,
      showActionButtons = _ref.showActionButtons,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      showFilterWarning = _ref.showFilterWarning,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      filterQuery = _ref.filterQuery,
      onFilterChange = _ref.onFilterChange,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting;
  var FederatedSearchIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Thought Industries federated search',
    toggleLabel: 'Enable Thought Industries federated search',
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchActive,
    storedIsSettingEnabled: storedState.isFederatedSearchActive,
    imageFromName: 'thought-industries-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    description: "Empower end users to search for Thought Industries content through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    onSave: onSave,
    onCancel: onCancel,
    onSettingChanged: onSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-thoughtindustries-federated-search',
    communityArticleLink: 'https://communities.gainsight.com/integrations-54/how-to-set-up-thought-industries-federated-search-21563',
    additionalHelpText: (0, _preact.h)(AdditionalHelpText, null),
    integrationStatus: (0, _preact.h)(_SyncContentStatus.default, {
      isInstalled: isInstalled,
      storedIsSettingEnabled: storedState.isFederatedSearchActive,
      statusUrl: "/integration/thoughtindustries/status",
      syncUrl: "/integration/thoughtindustries/sync"
    }),
    additionalInputFields: (0, _preact.h)(_IntegrationFilter.default, {
      onContentChange: onFilterChange,
      filterQuery: filterQuery,
      showFilterWarning: showFilterWarning,
      disabled: !isFederatedSearchActive && !storedState.isFederatedSearchActive
    }),
    isLoading: isSavingFederatedSearchSetting
  });
  return (0, _preact.h)("div", {
    className: "integration__tab thoughtindustries-integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: [FederatedSearchIntegrationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var AdditionalHelpText = function AdditionalHelpText() {
  var communityUrl = (0, _globals.default)('communityUrl');
  var safeUrl = (0, _utils.sanitizeUrl)(communityUrl);
  return (0, _preact.h)("span", null, "View Thought Industries content in the", ' ', (0, _preact.h)("a", {
    className: "overview-page-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(safeUrl.concat('/search')),
    rel: "noreferrer",
    target: "_blank"
  }, "search result"), ' ', "on the community destination.", ' ');
};

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      apiKey = _ref2.apiKey,
      onClickManage = _ref2.onClickManage,
      onApiKeyChangeCallback = _ref2.onApiKeyChangeCallback,
      onApiKeyClickCallback = _ref2.onApiKeyClickCallback,
      onSubdomainChangeCallback = _ref2.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref2.onSubdomainClickCallback,
      onClickUninstall = _ref2.onClickUninstall,
      subdomain = _ref2.subdomain,
      errorFields = _ref2.errorFields,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges,
      isSavingCredentials = _ref2.isSavingCredentials;
  var installationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onCancel: onCancel,
    apiKey: apiKey,
    onClickManage: onClickManage,
    onApiKeyChangeCallback: onApiKeyChangeCallback,
    onApiKeyClickCallback: onApiKeyClickCallback,
    onSubdomainChangeCallback: onSubdomainChangeCallback,
    onSubdomainClickCallback: onSubdomainClickCallback,
    onClickUninstall: onClickUninstall,
    subdomain: subdomain,
    errorFields: errorFields,
    hasUnsavedChanges: hasUnsavedChanges,
    isSavingCredentials: isSavingCredentials
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper thoughtindustries-installation__tab"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [installationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Thought Industries integration step by step",
    url: "https://communities.gainsight.com/integrations-54/how-to-set-up-thought-industries-federated-search-21563",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;